import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: for navigation buttons
import "swiper/css/pagination";
import imgevent from "../../assets/images/imgevent.webp";
import { MdChevronRight } from "react-icons/md";

export default function Swipi() {
  return (
    <div>
      <div className="block lg:hidden mt-7">
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            sm: {
              slidesPerView: 7,
            },
            lg: {
              slidesPerView: 10,
            },
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[120px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[120px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[120px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[120px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="hidden lg:block lg:mt-7">
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          breakpoints={{
            sm: {
              slidesPerView: 7,
            },
            lg: {
              slidesPerView: 10,
            },
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[115px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[115px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[115px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[115px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={imgevent}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[115px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}
